<template>
  <div :class="(lunBo == 0?'btn':lunBo == 1?'btn btn2':'btn btn3')+(Drawer?' icon3 ':' icon4 ')"
       :style="direction?' background-color: white !important;opacity: 1; color: #12466e;':''">
    <div class="btnn">
      <div class="lang-box">
        <el-image v-show="lunBo ==2 && direction" :src="logoL"
                  style="height: 52px;width: 55px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo ==2 && !direction" :src="logoB"
                  style="height: 52px;width: 55px;margin-left: 10px"></el-image>
        <el-image v-show="lunBo != 2" :src="logoB2"
                  style="height: 30px;width: 33px;padding-top: 2px;margin-left: 18px"></el-image>
      </div>
      <div style="display: flex;align-items: center">
        <el-tooltip :show-arrow="false" placement="bottom" effect="light">
          <div>
            <svg t="1718679241670" :class="lunBo ==2 && !direction?'icon2':'icon1'" viewBox="0 0 1070 1024"
                 version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="11216" width="20" height="20">
              <path
                  d="M232.582 358.133c12.288 36.33 32.59 67.851 60.905 95.633 24.042-26.18 42.207-58.235 53.96-95.633H232.583z"
                  p-id="11217"></path>
              <path
                  d="M981.615 143.36H532.836L507.192 6.055H90.468C44.522 6.055 7.123 43.453 7.123 89.4v708.43c0 45.946 37.399 83.344 83.345 83.344h379.86l-30.453 137.305h541.74c45.947 0 83.345-37.398 83.345-83.344v-708.43c0-45.947-37.398-83.345-83.345-83.345zM415.833 564.358c-49.152-18.165-89.756-41.139-122.346-67.852-34.192 30.453-76.933 52.892-126.62 66.783l-17.096-28.316c48.618-12.822 89.222-32.055 121.277-59.303-33.124-33.658-56.097-72.66-68.92-117.003h-46.48v-32.056h121.277c-7.48-13.89-17.096-27.247-28.316-40.07l32.056-11.753c11.22 14.425 21.37 31.522 30.453 51.29h115.935v32.055h-46.481c-14.96 45.946-36.33 84.413-64.646 115.4 31.522 25.11 71.057 45.947 117.538 63.043l-17.631 27.782zM1023.288 934.6c0 22.974-18.7 41.673-41.673 41.673H492.232l20.837-95.633h156.538l-89.222-497.397-0.534 2.671-3.74-19.767 1.069 0.534-32.59-181.649h437.56c22.973 0 41.672 18.7 41.672 41.673V934.6z"
                  p-id="11218"></path>
              <path
                  d="M684.566 541.384h114.866v-30.453H684.566v-60.905h122.346v-30.453H648.771V638.62h162.95v-30.453H684.565v-66.783zM924.45 475.67c-9.616 0-18.164 1.603-26.178 5.877-7.48 3.74-14.96 9.617-20.837 17.096v-18.699h-34.727V638.62h34.727v-95.633c1.069-12.822 5.343-22.439 12.823-29.384 6.41-5.877 13.89-9.083 22.439-9.083 24.041 0 35.795 12.823 35.795 39.001v94.565h34.727v-97.77c1.069-43.275-19.233-64.646-58.769-64.646z"
                  p-id="11219"></path>
            </svg>
          </div>
          <template #content>
            <div>
              <div @click="setZhongYing()" class="zi">English</div>
            </div>
          </template>
        </el-tooltip>
        <svg t="1718865040977" @click="Drawer = true" v-show="!Drawer"
             :class="(lunBo == 1?'icon1 ':'icon2 ')"
             viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="4575">
          <path
              d="M867.1 141.17H156.08c-17.67 0-32 14.33-32 32s14.33 32 32 32H867.1c17.67 0 32-14.33 32-32s-14.33-32-32-32zM867.92 367.52H403.2c-17.67 0-32 14.33-32 32s14.33 32 32 32h464.73c17.67 0 32-14.33 32-32s-14.33-32-32.01-32zM867.92 573.87H403.2c-17.67 0-32 14.33-32 32s14.33 32 32 32h464.73c17.67 0 32-14.33 32-32s-14.33-32-32.01-32zM867.92 800.22H156.9c-17.67 0-32 14.33-32 32s14.33 32 32 32h711.02c17.67 0 32-14.33 32-32 0-17.68-14.32-32-32-32zM312.01 367.52v270.35L137.47 489.71z"
              p-id="4576"></path>
        </svg>
        <svg t="1718864712238" @click="Drawer = false" v-show="Drawer"
             :class="(lunBo == 1?'icon1 ':'icon2 ')"
             viewBox="0 0 1024 1024" version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             p-id="4413">
          <path
              d="M867.1 141.17H156.08c-17.67 0-32 14.33-32 32s14.33 32 32 32H867.1c17.67 0 32-14.33 32-32s-14.33-32-32-32zM867.92 367.52H403.2c-17.67 0-32 14.33-32 32s14.33 32 32 32h464.73c17.67 0 32-14.33 32-32s-14.33-32-32.01-32zM867.92 573.87H403.2c-17.67 0-32 14.33-32 32s14.33 32 32 32h464.73c17.67 0 32-14.33 32-32s-14.33-32-32.01-32zM867.92 800.22H156.9c-17.67 0-32 14.33-32 32s14.33 32 32 32h711.02c17.67 0 32-14.33 32-32 0-17.68-14.32-32-32-32zM137.47 637.87V367.52l174.54 148.15z"
              p-id="4414"></path>
        </svg>
      </div>
    </div>
  </div>
  <el-drawer
      v-model="Drawer"
      direction="rtl"
      :show-close="false"
      :close-on-click-modal="false"
      :lock-scroll="true"
      size="45%"
  >
    <div class="demo-collapse" style="position: absolute;top:15px;width: 100%;">
      <div v-for="(item,index) in store.state.navigationBar">
        <div class="collapse3">
          <div v-if="store.state.navigationBar[index].bar == null"
               @click="goto(item)"
               :class="index !=0?'collapse':'collapse2'">
            {{ item.title }}
          </div>
          <div v-if="store.state.navigationBar[index].bar != null"
               @click="goto2(index)"
               :class="index != 0?'collapse':'collapse2'">
            {{ item.title }}
          </div>
        </div>
        <div v-if="(store.state.navigationBar[index].bar != null) && collapse == index"
             :class="index !=0?'collapse4':'collapse5'"
             @click="goto3(item,index,item2)"
             v-for="(item2,index2) in store.state.navigationBar[index].bar">
          {{ item2.name }}
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script setup>
import {inject, onMounted, defineEmits, defineProps, ref, reactive, getCurrentInstance, onDeactivated} from 'vue';
import {useRouter} from "vue-router";
import store from "@/store";
import logoB from '@/assets/logo/logo白.png'
import logoB2 from '@/assets/logo/logo白2.png'
import logoL from '@/assets/logo/logo蓝.png'
import zhong from '@/assets/中文.png'
import ying from '@/assets/英文.png'
import 'animate.css';

let Drawer = ref(false)
let collapse = ref(-1)
let direction = ref(false)
const router = useRouter();
let barList = ref([])
let lunBo = ref(0)

const setZhongYing = () => {
  window.location.href = (window.location.protocol + '//' + window.location.host + '/EN' + window.location.pathname + window.location.search)
}

const handleScroll = () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  if (scrollTop > 0) lunBo.value = 1;
  if (scrollTop == 0) lunBo.value = 2;
}
const goto = (item) => {
  Drawer.value = false
  collapse.value = -1
  store.commit('gotoUrl', {url: item.url, bar: item.title, barTitleUrl: item.url})
}
const goto3 = (item, index, item2) => {
  Drawer.value = false
  collapse.value = -1
  store.commit('gotoUrl', {url: item2.url, bar: store.state.navigationBar[index].title, barTitleUrl: item.url})
}
const goto2 = (index) => {
  collapse.value = index
}
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll()
})
onDeactivated(() => {
  window.removeEventListener('scroll', handleScroll, true);
})

</script>

<style scoped lang="less">
.none {
  display: none !important;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  position: fixed;
  top: 0px;
  z-index: 10000;
  color: white;
}

.btnN {
  background-color: white !important;
  opacity: 1;
  color: #12466e;
}

.btnn {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  z-index: 5000;
  padding: 20px;
  box-sizing: border-box;
}


.btn2 {
  background-color: rgba(255, 255, 255, 1);
  height: 60px;
  animation: btnDong 1s;
  position: fixed;
  top: 0px;
  color: #12466e;
}

.btn3 {
  background-color: transparent;
  height: 90px;
  position: fixed;
  top: 0px;
  animation: btnDong2 1s;
  opacity: 1;
}

@keyframes btnDong {
  0% {
    background-color: transparent;
    height: 90px;
  }
  100% {
    background-color: rgba(255, 255, 255, 1);
    height: 60px;
  }
}

@keyframes btnDong2 {
  100% {
    background-color: transparent;
    height: 90px;
  }
  0% {
    background-color: white;
    height: 60px;
  }
}

.lang-box {
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  top: 0px;
  z-index: 2000;
}

.lang-box2 {
  display: flex;
  height: 100%;
  align-items: center;
  cursor: pointer
}

.lang-box2-btn {
  display: flex;
  align-items: center;
  padding: 10px 0px;
  box-sizing: border-box
}

.scroll .lang-box {
  border: 1px solid #ddd
}

.lang-box a {
  background: 0 0;
  padding: 0 8px;
  display: inline-block
}

.lang-box a.active, .scroll .lang-box a.active {
  background: #fff;
}

.btnText {
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.btnText2 {
  color: #f26228;
  font-weight: 700;
  margin: 0 20px 0 20px;
  font-size: 18px;
  cursor: pointer;
}

.animate__faster__btn {
  --animate-duration: 0.15s;
}

.btnTextColor {
  color: #f26228;
}

.btnH1 {
  position: absolute;
  top: 50%;
  margin: 0 10%;
  transform: translate(0%, -50%);
}

.zibtn {
  position: fixed;
  top: 0;
  background-color: white;
  width: 100%;
  animation: zibtn2 0.5s;
  z-index: 1000;
}

@keyframes zibtn2 {
  100% {
    top: 0px;
  }

  0% {
    top: -100%;
  }
}

.barzi:hover {
  color: #f26228;
}

.barzi2 {
  padding: 15px 30px;
  color: #666666;
  font-weight: 300;
  width: 100%;
  white-space: nowrap;

}

.barzi2:hover {
  color: #f26228;
}

.zibtnD {
  padding: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-wrap: wrap;
}

.zibtnDiv {
  display: flex;
  margin: 0 20%;
  padding: 30px 20px;
  box-sizing: border-box;
  justify-content: space-around;
  color: #555555;
  font-weight: 600;
  align-items: flex-start;
}

.you {
  width: 10px;
  margin-top: 10px;
  margin-right: 10px;
}

.icon1 {
  fill: #12466e;
  margin: 0px 5px;
  width: 40px;
  height: 40px
}

.icon2 {
  fill: white;
  margin: 0px 5px;
  width: 40px;
  height: 40px
}

.icon3 {
  width: calc(55vw);
  animation: icon3s 0.4s;
}

@keyframes icon3s {
  100% {
    width: calc(55vw);
  }
  0% {
    width: calc(100vw);
  }
}


.zi {
  padding: 8px 13px;
  cursor: pointer;
  font-size: 16px;
}

.zi:hover {
  color: #12466e;
  background-color: #ecf5ff;
}

.collapse {
  padding: 15px;
  border-top: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.collapse2 {
  padding: 15px;
  box-sizing: border-box;
}

.collapse3 {
  box-sizing: border-box;
}

.collapse3:active {
  background-color: #ecf5ff;
}

.collapse4 {
  padding: 15px 15px 15px 25px;
  border-top: 1px solid #dcdfe6;
  box-sizing: border-box;
}

.collapse5 {
  padding: 15px 10px 15px 15px;
  box-sizing: border-box;
}
</style>
